
  export default {
    data() {
      return {
        contingents: [
          {
            color: '#E4BF7B',
            name: '50.000 pbCoins',
            number_of_coins: '2.500 pbCoins',
            price_per_quota: '1.000 €',
          },
          {
            color: '#DCA441',
            name: '100.000 pbCoins',
            number_of_coins: '6.000 pbCoins',
            price_per_quota: '2.000 €',
          },
          {
            color: '#6E8DB5',
            name: '150.000 pbCoins',
            number_of_coins: '10.500 pbCoins',
            price_per_quota: '3.000 €',
          },
          {
            color: '#6E8DB5',
            name: '200.000 pbCoins',
            number_of_coins: '16.000 pbCoins',
            price_per_quota: '4.000 €',
          },
          {
            color: '#3D6190',
            name: '250.000 pbCoins',
            number_of_coins: '25.000 pbCoins',
            price_per_quota: '5.000 €',
          },
        ],
      };
    },
  };
